import {
  CategoryName,
  DisplayModeOutParamName,
  TControlName,
} from '@infotech-soe/metaschema';

import {
  FormControlViewModel,
  FormControlViewModelType,
} from '../../view-model/FormControlViewModel';
import {
  FormControls,
  FormUpdateWithDictOutputViewModel,
} from '../../view-model/FormViewModel';

// TODO move to utils or typeguards
function assertDate(value: unknown): asserts value is Date | string | number {
  if (Number.isNaN(Date.parse(value as string))) {
    throw new TypeError(`Wrong type of outParams`);
  }
}

const castValueBasedOnControlType = (
  control: FormControlViewModel,
  value: unknown
) => {
  if (control.type === FormControlViewModelType.DICT_DATE) {
    assertDate(value);
    return new Date(value);
  }

  return value;
};

const updateDictWithParams = async (
  outParams: Record<DisplayModeOutParamName, TControlName | TControlName[]>,
  value: string | Record<string, any>,
  formControls: FormControls,
  controlName: TControlName,
  apiVars: Map<string, any>
): Promise<FormUpdateWithDictOutputViewModel> => {
  const args: Record<TControlName, any> = {};
  const controls: FormControls = {};

  const control = formControls[controlName];

  if (typeof value === 'string' && control.hasValue) {
    if (control.type !== FormControlViewModelType.DICTIONARY_INPUT) {
      throw new Error('Unsupported form control');
    }
    controls[controlName] = {
      ...control,
      value,
    };
    args[controlName] = value;
  } else {
    Object.entries(outParams).forEach(([outParamName, ctrlNames]) =>
      (Array.isArray(ctrlNames) ? ctrlNames : [ctrlNames]).forEach(ctrlName => {
        controls[ctrlName] = { ...formControls[ctrlName] };
        const currentControl = controls[ctrlName];
        if (typeof value === 'object') {
          const castedValue = castValueBasedOnControlType(
            currentControl,
            value[outParamName]
          );
          if (currentControl.hasValue) {
            currentControl.value = castedValue;
          }
          args[ctrlName] = castedValue;
        }
      })
    );
  }

  return {
    controls,
    args,
    skipNextUpdater: false,
    apiVars,
    triggered: true,
  };
};

const updateDict = (
  controlName: TControlName,
  outParams: Record<DisplayModeOutParamName, TControlName | TControlName[]>,
  value: any,
  formControls: FormControls,
  _category: CategoryName,
  apiVars: Map<string, any>
): Promise<FormUpdateWithDictOutputViewModel> =>
  updateDictWithParams(outParams, value, formControls, controlName, apiVars);

export default updateDict;
